module.exports = __webpack_public_path__ + "img/4.96350e53.jpg";